import React from 'react'

import CPUIcon from 'components/icons/CPUIcon'
import DownloadStack from 'components/icons/DownloadStack'

/**
 * Devuelve el menú al que pertenece la URL detectada
 * @param {string} pathname
 * @returns {{ menuName: string, level: number } | null}
 */
export const getMenuLevelFromURL = pathname => {
  // Level 1
  if (pathname.includes('/dashboard/conversations')) return { menuName: 'nav_conversations_title', level: 1 }
  if (pathname.includes('/dashboard/automation')) return { menuName: 'nav_configurations_automation', level: 1 }
  if (pathname.includes('/dashboard/marketing')) return { menuName: 'nav_crm_marketing', level: 1 }
  if (pathname.includes('/dashboard/management')) return { menuName: 'nav_management_title', level: 1 }
  if (pathname.includes('/dashboard/configurations')) return { menuName: 'nav_configurations_title', level: 1 }
  if (pathname.includes('/dashboard/integrations')) return { menuName: 'nav_integrations', level: 1 }

  return null
}

/**
 * Devuelve el type del ícono a utilizar de S3
 * @param {string} menuItemName
 * @returns {string}
 */
export const getMenuItemIcon = (menuItemName) => {
  switch (menuItemName) {
    case 'nav_dashboard':
      return 'home'
    case 'nav_conversations_title':
    case 'nav_configurations_messages':
      return 'chat'
    case 'nav_inchat':
      return 'inchat'
    case 'nav_configurations_automation':
    case 'nav_configurations_console_faqs':
    case 'nav_configurations_smartchat':
      return 'automation'
    case 'nav_crm_marketing':
    case 'nav_crm_marketing_campaigns':
      return 'campaign'
    case 'nav_crm_marketing_distribution_lists':
      return 'list'
    case 'nav_management_title':
    case 'nav_configurations_businessModel':
      return 'briefcase'
    case 'nav_configurations_title':
    case 'nav_configurations_botConfiguration':
      return 'config'
    case 'nav_legalNotice_title':
    case 'nav_bookings_title':
      return 'book'
    case 'nav_conversations_search':
      return 'search'
    case 'nav_conversations_lists':
    case 'nav_folders':
      return 'folder'
    case 'nav_conversations_users':
    case 'nav_management_operators':
      return 'user-slim'
    case 'nav_conversations_assignations':
      return 'user-asign'
    case 'nav_crm_marketing_templates':
      return 'template'
    case 'nav_metrics_title':
      return 'template'
    case 'nav_metrics':
    case 'nav_configurations_console_faqs_metrics':
    case 'nav_configurations_smartchat_metrics':
      return 'metrics'
    case 'nav_crm_marketing_create_campaigns':
      return 'plus-circle'
    case 'nav_management_company':
      return 'company'
    case 'roles_title':
      return 'users-slim'
    case 'nav_management_plan':
      return 'money-circle'
    case 'nav_configurations_channels':
      return 'channels'
    case 'nav_management_credentials':
      return 'credential'
    case 'nav_configurations_notifications':
      return 'notification'
    case 'nav_categories':
      return 'label'
    case 'nav_company_resources':
      return 'book-open'
    case 'nav_configurations_nauta':
      return 'nauta'
    case 'nav_configurations_survey':
      return 'survey'
    case 'nav_intranet_title':
      return 'code'
    case 'nav_intranet_translations':
      return 'earth'
    case 'nav_legalNotice_conditions':
    case 'nav_legalNotice_privacy':
    case 'nav_legalNotice_cookies':
      return 'external-link'
    case 'nav_metrics_datasets':
      return 'datasets'
    case 'nav_metrics_panels':
      return 'chart-board'
    case 'nav_integrations':
      return 'squares-plus'
    case 'nav_integrations_external_identification':
      return 'id'
    case 'nav_integrations_api_app':
      return <CPUIcon />
    case 'nav_managements_download_data':
      return <DownloadStack />
    default:
      return 'na'
  }
}
